export default async function getMenuData() {
  return [
    {
      category: true,
      title: 'Dashboards',
    },
    {
      title: 'Dashboards',
      key: 'dashboards',
      icon: 'fe fe-home',
      // roles: ['admin'], // set user roles with access to this route
      count: 4,
      children: [
        {
          title: 'Alpha',
          key: 'dashboard',
          url: '/dashboard/alpha',
        },
        {
          title: 'Beta',
          key: 'dashboardBeta',
          url: '/dashboard/beta',
        },
        {
          title: 'Gamma',
          key: 'dashboardGamma',
          url: '/dashboard/gamma',
        },
        {
          title: 'Crypto Terminal',
          key: 'dashboardCrypto',
          url: '/dashboard/crypto',
        },
      ],
    }
  ]
}
